// part of nuxt
import type { $Fetch, NitroFetchRequest } from "nitropack"

export function contentRepository<T>(fetch: $Fetch<T, NitroFetchRequest>) {
  return {
    /**
     * Returns all visible content modules of the page
     * @param tenantId targeted tenant
     * @param jobShopId id of the JobShop from which the page is part of
     * @param pageId id of the page from which the content modules are part of
     * @param locale language locale for the Accept-Language header
     * @returns
     */
    async getContentModules(tenantId: string, jobShopId: string, pageId: string, locale: string): Promise<ContentModule[]> {
      return fetch<ContentModule[]>(`${UrlConfig.PATH_BASE_CONTENT_SERVICE}/public/pages/${pageId}/content-modules`, {
        headers: {
          "Accept-Language": locale,
          "Accept": "application/json",
          "X-Tenant-Id": tenantId,
          "X-JobShop-Id": jobShopId,
        },
      })
    },
  }
}
